/**
 * @description
 * Objeto PersonsByIdNumCtrlDig
 */

export class PersonsByIdNumCtrlDig {
    
    public dboid: string;
    public idnumber: string;
    public ctrldigit: string;
    public fullname: string;
    public vatacronym: string;
    public nif: string;
    public active: boolean;
    public nom: string;
    public cognom1: string;
    public cognom2: string;
    public nommostrar: string;
  
    constructor() {}
  
}